import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { prependUserLists, setActiveUserList, updateUserLists } from '../../../redux/actions/userLists';
import { useTheme } from '@mui/material/styles';
import { setAlert } from '../../../redux/actions';
import { alpha, styled } from '@mui/material/styles';

const CHARACTER_LIMIT = 64;

const Create = ({ show, setShow, edit, setEdit }) => {
    const dispatch = useDispatch();
    const theme = useTheme();

    const [name, setName] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [editID, setEditID] = useState('');

    const handleClose = () => {
        setShow(false);
    };

    const handleCreate = () => {
        if (!name || name.length <= 0) {
            setError('The list name field is required');
            return;
        }

        setBusy(true);
        if (editID) {
            axios.patch('/api/user-lists', {
                id: editID,
                name: name
            })
                .then(response => {
                    setBusy(false);
                    setShow(false);
                    dispatch(updateUserLists(response.data.data));
                    dispatch(setActiveUserList(response.data.data));
                    dispatch(setAlert({
                        show: true,
                        type: 'success',
                        body: 'User list successfully updated'
                    }));
                    setEdit({});
                    setEditID('');
                })
                .catch(error => {
                    setBusy(false);
                    if (error.response) {
                        if (error.response.status === 422) {
                            const responseData = error.response.data;
                            const firstErrorKey = Object.keys(responseData.errors);
                            setError(responseData.errors[firstErrorKey[0]]);
                        }
                    }
                });
        } else {
            axios.post('/api/user-lists', {
                name: name
            })
                .then(response => {
                    setBusy(false);
                    dispatch(prependUserLists(response.data));
                    setShow(false);
                })
                .catch(error => {
                    setBusy(false);
                    if (error.response) {
                        if (error.response.status === 422) {
                            const responseData = error.response.data;
                            const firstErrorKey = Object.keys(responseData.errors);
                            setError(responseData.errors[firstErrorKey[0]]);
                        }
                    }
                });
        }
    };

    const handleNameChange = e => {
        const value = e.target.value;

        if (value) {
            setError('');
        }

        setName(value);
    };

    useEffect(() => {

        return () => {
            setError('');
        };
    }, []);

    useEffect(() => {
        if (edit && Object.keys(edit).length > 0) {
            setName(edit.name);
            setEditID(edit.id);
        }
        return () => {
            setError('');
        };
    }, [edit]);

    useEffect(() => {

        if (!show) {
            setError('');
        }
        return () => {
            setError('');
        };
    }, [show]);

    return <Dialog
        className='user-list-form'
        open={show}
        onClose={handleClose}
        sx={{
            '& .MuiDialog-paper': {
                maxWidth: '400px',
                width: 400
            },
        }}
    >
        <DialogTitle
            sx={{
                color: '#0097fe'
            }}
        >{editID ? 'Rename' : 'Create New'} User List</DialogTitle>
        <DialogContent>
            <ThemeProvider theme={theme}>
                <TextField
                    required
                    fullWidth
                    autoFocus
                    margin="dense"
                    id="name"
                    label="List name"
                    variant="outlined"
                    value={name}
                    onChange={handleNameChange}
                    inputProps={{
                        maxLength: CHARACTER_LIMIT
                    }}
                    helperText={`${name.length}/${CHARACTER_LIMIT}`}
                    disabled={busy}
                    error={!!error}
                    size='small'
                />
                {
                    <span style={{ color: theme.palette.error.main }}>{error}</span>
                }
            </ThemeProvider>
        </DialogContent>
        <DialogActions>
            <Button
                onClick={handleClose}
                disabled={busy}
            >Cancel</Button>
            <Button
                onClick={handleCreate}
                disabled={busy}
            >
                {
                    editID
                        ? (busy ? 'Updating...' : 'Update')
                        : (busy ? 'Creating...' : 'Create')
                }
            </Button>
        </DialogActions>
    </Dialog>;
};

export default Create;